import React from 'react'
import { Box, Tooltip } from '@mui/material'
import CloudDoneIcon from '@mui/icons-material/CloudDone'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import CloudOffIcon from '@mui/icons-material/CloudOff'
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'

const STATES = {
  saving:  { Icon: CloudUploadIcon,          color: '#f59e0b', tip: 'Saving…',        pulse: true  },
  saved:   { Icon: CloudDoneIcon,            color: '#10b981', tip: 'Saved',           pulse: false },
  error:   { Icon: ReportProblemOutlinedIcon,color: '#ef4444', tip: 'Save failed',     pulse: false },
  unsaved: { Icon: CloudOffIcon,             color: '#64748b', tip: 'Unsaved changes', pulse: false },
}

function SaveIndicator({ status }) {
  const conf = STATES[status]
  if (!conf) return null
  const Icon = conf.Icon

  return (
    <Tooltip title={conf.tip} placement="bottom" arrow>
      <Box sx={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: 18, height: 18, cursor: 'default',
        ...(conf.pulse && {
          '@keyframes iconPulse': {
            '0%, 100%': { opacity: 1 },
            '50%':      { opacity: 0.35 },
          },
          animation: 'iconPulse 1.6s ease-in-out infinite',
        }),
      }}>
        <Icon sx={{ fontSize: 13, color: conf.color }} />
      </Box>
    </Tooltip>
  )
}

export default SaveIndicator
